import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { IPayerRow } from "../../../../services/search";
import { getPayerNames } from "../../../Payers/utils/getPayerNames";
import { getWorkLogPayeeStatusCellProps } from "../../utils/getWorkLogPayeeStatusCellProps";
import { TableItemData } from "./TableWorkLogsPayeeView";

type ColumnsConfig = {
  payersMap: Map<string, IPayerRow>;
  invoicesMap?: Map<string, IInvoice>;
};

export const getColumns = ({
  payersMap,
  invoicesMap
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: {
        text: "Client"
      }
    },
    renderFunction: item => {
      // TODO(v3): v3 WorkLog dropped `payerId`; payersMap is empty so the client
      // name no longer resolves (accepted breakage).
      const payer = payersMap.get(
        (item.data as { payerId?: string }).payerId ?? ""
      );
      if (!payer) {
        return <WSTableCell text="-" />;
      }
      const names = getPayerNames(payer);
      return (
        <WSTableCell
          text={names.getResolvedName()}
          secondaryText={names.getResolvedSecondaryName()}
          truncationOptions={{
            text: { allowTwoLines: true }
          }}
        />
      );
    }
  },
  {
    config: {
      header: {
        text: "Work log #"
      }
    },
    renderFunction: item => <WSTableCell text={item.data.workLogNumber} />
  },
  {
    config: {
      header: {
        text: "Amount"
      }
    },
    renderFunction: item => (
      <WSTableCell text={formatMoney(item.data.totalAmount ?? 0, "USD")} />
    )
  },
  {
    config: {
      header: {
        text: "Last modified"
      }
    },
    // TODO(v3): v3 WorkLog has no `updatedAt`; approximate "Last modified" with
    // the in-review event timestamp.
    renderFunction: item => (
      <WSTableCell
        text={toWSDateString(item.data.events?.inReviewAt, "timeframe")}
      />
    )
  },
  {
    config: {
      header: {
        text: "Status"
      }
    },
    renderFunction: item => {
      // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
      const invoice = invoicesMap?.get(item.data.convertedResourceId || "");

      const cellProps = getWorkLogPayeeStatusCellProps({
        workLog: item.data,
        invoice
      });

      return <WSTableCell {...cellProps} />;
    }
  }
];
